import { CustomToastComponent } from "@/components/shared";
import { useMutation } from "@apollo/client/react";
import {
  PaginatedChristmasBonusDocument,
  RemoveChristmasBonusMutation,
  RemoveChristmasBonusMutationVariables,
  RemoveChristmasBonusDocument,
} from "@/graphql/__generated__/graphql";
import { resetPaginationField } from "@/store/paginationStore";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

/**
 * Custom hook for removing a christmas bonus and handling the necessary cache updates.
 * @returns {Object} - Contains the removeChristmasBonusMutation function, loading state, and error state.
 */
export default function useRemoveChristmasBonusMutationHook(): {
  removeChristmasBonusMutation: any;
  loading: any;
  error: any;
  } {
  const { t } = useTranslation(["toasts"]);

  const [removeChristmasBonusMutation, { loading, error }] = useMutation<RemoveChristmasBonusMutation, RemoveChristmasBonusMutationVariables>(
    RemoveChristmasBonusDocument, {
      onCompleted: () => {
      // Reset pagination to first page to avoid cache inconsistencies
        resetPaginationField("paginatedChristmasBonus");

        toast(CustomToastComponent, {
          toastId: "christmas-bonus-removed-success",
          data: {
            title: t("toasts.christmasbonusremovedsuccessfully"),
            type: "success",
          },
        });
      },
      refetchQueries: [
        {
          query: PaginatedChristmasBonusDocument,
          variables: {
            first: 10,
            after: null,
            filters: {
              activeFrom: null,
              bonusAbsolute: null,
              bonusRelative: null,
              provinces: null,
            },
            sort: null,
          },
        },
      ],
    });

  return {
    removeChristmasBonusMutation,
    loading,
    error,
  };
}
